module.exports = __webpack_public_path__ + "img/f49.e7912d1d.png";